<template>
  <div id="app">
    <nav class="navbar has-shadow" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item">
          <router-link to="/" exact>
            <img src="./assets/logo.svg" />
          </router-link>
        </a>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="footWizardNavbar"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div id="footWizardNavbar" class="navbar-menu">
        <div class="navbar-start">
          <router-link to="/" class="navbar-item" exact>{{ $translate('home') }}</router-link>
          <router-link
            to="/companies"
            class="navbar-item"
            v-if="$store.getters.user.userInfo.type == 'A' || $store.getters.user.userInfo.type == 'I'"
            >{{ $translate('customers') }}
          </router-link>
          <router-link to="/shops" class="navbar-item" v-if="isLogged">{{ $translate('shops') }}</router-link>
          <router-link to="/patients" class="navbar-item" v-if="isLogged">{{ $translate('patients') }}</router-link>
          <router-link to="/orders" class="navbar-item" v-if="isLogged">{{ $translate('orders') }}</router-link>
          <router-link to="/catalogs" class="navbar-item" v-if="isLogged"
            ><span>{{ $translate('catalogs') }}</span></router-link
          >
          <b-navbar-dropdown
            label="su misura"
            v-if="$store.getters.user.userInfo.type == 'A' || $store.getters.user.userInfo.type == 'I'"
          >
            <router-link :to="{ name: 'materials', params: { module: 'tailored' } }" class="navbar-item">{{
              $translate('materials') | capitalize
            }}</router-link>

            <router-link :to="{ name: 'mods', params: { module: 'tailored' } }" class="navbar-item">{{
              $translate('models') | capitalize
            }}</router-link>
          </b-navbar-dropdown>
          <b-navbar-dropdown
            label="FITS"
            v-if="$store.getters.user.userInfo.type == 'A' || $store.getters.user.userInfo.type == 'I'"
          >
            <router-link :to="{ name: 'materials', params: { module: 'fits' } }" class="navbar-item">{{
              $translate('materials') | capitalize
            }}</router-link>
            <router-link :to="{ name: 'shapes', params: { module: 'fits' } }" class="navbar-item"
              >{{ $translate('shapes') | capitalize }}
            </router-link>
            <router-link :to="{ name: 'soles', params: { module: 'fits' } }" class="navbar-item"
              >{{ $translate('soles') | capitalize }}
            </router-link>
            <router-link :to="{ name: 'mods', params: { module: 'fits' } }" class="navbar-item"
              >{{ $translate('models') | capitalize }}
            </router-link>
          </b-navbar-dropdown>
          <b-navbar-dropdown
            label="Modular"
            v-if="$store.getters.user.userInfo.type == 'A' || $store.getters.user.userInfo.type == 'I'"
          >
            <router-link :to="{ name: 'materials', params: { module: 'modular' } }" class="navbar-item">{{
              $translate('materials') | capitalize
            }}</router-link>
            <router-link :to="{ name: 'allestimenti', params: { module: 'modular' } }" class="navbar-item">{{
              $translate('newAllestimento') | capitalize
            }}</router-link>
            <router-link :to="{ name: 'shapes', params: { module: 'modular' } }" class="navbar-item"
              >{{ $translate('shapes') | capitalize }}
            </router-link>
            <router-link :to="{ name: 'soles', params: { module: 'modular' } }" class="navbar-item"
              >{{ $translate('soles') | capitalize }}
            </router-link>
            <router-link :to="{ name: 'mods', params: { module: 'modular' } }" class="navbar-item"
              >{{ $translate('models') | capitalize }}
            </router-link>
          </b-navbar-dropdown>
          <b-navbar-dropdown
            label="Insole"
            v-if="$store.getters.user.userInfo.type == 'A' || $store.getters.user.userInfo.type == 'I'"
          >
            <router-link :to="{ name: 'materials', params: { module: 'insole' } }" class="navbar-item">{{
              $translate('materials') | capitalize
            }}</router-link>
            <router-link :to="{ name: 'mods', params: { module: 'insole' } }" class="navbar-item"
              >{{ $translate('models') | capitalize }}
            </router-link>
          </b-navbar-dropdown>
          <router-link to="/users" class="navbar-item" v-if="$store.getters.user.userInfo.type == 'A'"
            >{{ $translate('users') }}
          </router-link>
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <b-dropdown aria-role="list">
              <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                <span>{{ $i18n.locale | uppercase }}</span>
                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
              </button>
              <b-dropdown-item aria-role="listitem" @click="changeLanguage('it')">IT</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeLanguage('en')">EN</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeLanguage('dk')">DK</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeLanguage('de')">DE</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeLanguage('fr')">FR</b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="navbar-item">
            <b-button
              type="is-primary"
              @click="
                $translateMode = !$translateMode
                $forceUpdate()
              "
            >
              <b-icon :icon="$translateMode ? 'minus-circle' : 'translate'"></b-icon>
            </b-button>
          </div>
          <div class="navbar-item">
            <b-button type="is-primary" @click="loginButtonAction()">
              {{ isLogged ? 'Logout' : 'Login' }}
            </b-button>
          </div>
        </div>
      </div>
    </nav>
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
// @ is an alias to /src
import firebase from 'firebase'
import permissionMixin from '@/helpers/mixins/permissionMixin'
;(function() {
  const host = window.location.hostname
  if (host === 'footwizarddev.web.app' || host === 'footwizarddev.firebaseapp.com') {
    window.location.replace('https://dev.footura.duna.it' + window.location.pathname + window.location.search)
  }
  if (host === 'footwizardweb.web.app' || host === 'footwizardweb.firebaseapp.com') {
    window.location.replace('https://footura.duna.it' + window.location.pathname + window.location.search)
  }
})()
export default {
  data() {
    return {
      loggedUser: {},
      isLogged: false,
    }
  },
  mixins: [permissionMixin],
  methods: {
    changeLanguage(newcode) {
      this.$i18n.locale = newcode
    },
    loginButtonAction() {
      if (!this.isLogged) {
        this.$router.push({ name: 'login' })
      } else {
        this.$store.commit('emptyUser')
        firebase.auth().signOut()
        this.isLogged = false
        //this.$router.push("/");
      }
    },
  },
  mounted() {
    if (this.$store.getters.user.userInfo) {
      this.loggedUser = this.$store.getters.user
    }
    if (this.loggedUser.userInfo.type != '') {
      this.isLogged = true
    } else {
      this.isLogged = false
    }
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.isLogged = true
      } else {
        this.isLogged = false
      }
    })
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
      // Add a click event on each of them
      $navbarBurgers.forEach(el => {
        el.addEventListener('click', () => {
          // Get the target from the "data-target" attribute
          const target = el.dataset.target
          const $target = document.getElementById(target)

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle('is-active')
          $target.classList.toggle('is-active')
        })
      })
    }
  },
}
</script>

<style lang="scss">
// Import Bulma's core
@import '~bulma/sass/utilities/_all';
// Set custom variables
$primary: #008a6b;
$primary-invert: #fff;
$secondary: #ff9a00;
$secondary-invert: #fff;
$insole: #ce4760;
$insole-invert: #fff;
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  'primary': (
    $primary,
    $primary-invert,
  ),
  'secondary': (
    $secondary,
    $secondary-invert,
  ),
  'insole': (
    $insole,
    $insole-invert,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;
// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

// Import Custom global styles
@import './assets/css/global.css';
</style>
